import React, { useState } from "react";
import "./Gallery.css";

const images = [
  "/images/1.png",
  "/images/2.png",
  "/images/3.png",
  "/images/4.png",
  "/images/5.png",
  "/images/6.png",
  "/images/7.png",
  "/images/8.png",
  "/images/9.png",
  "/images/10.png",
  "/images/11.png",
  "/images/12.png",
];

const Gallery = () => {
  const [current, setCurrent] = useState(null);

  const openImage = (index) => {
    setCurrent(index);
  };

  const closeImage = () => {
    setCurrent(null);
  };

  const prev = () => {
    setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const next = () => {
    setCurrent((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="gallery" className="gallery">
      <h2>Gallery</h2>

      {/* GRID */}
      <div className="grid">
        {images.map((img, i) => (
          <div key={i} className="grid-item" onClick={() => openImage(i)}>
            <img src={img} alt="" />
          </div>
        ))}
      </div>

      {/* LIGHTBOX */}
      {current !== null && (
        <div className="lightbox">
          <span className="close" onClick={closeImage}>×</span>

          <button className="prev" onClick={prev}>❮</button>

          <img src={images[current]} alt="" className="lightbox-img" />

          <button className="next" onClick={next}>❯</button>
        </div>
      )}
    </section>
  );
};

export default Gallery;